import React, { type FunctionComponent, useState, useEffect } from 'react';
import { UnorderedList, OrderedList, ListItem, Heading } from '@chakra-ui/react';

interface Props {
    markdown: string;
}

export const MarkDownBox: FunctionComponent<Props> = (props: Props) => {
    const [Markdown, setMarkdown] = useState<React.ComponentType<any> | null>(null);

    useEffect(() => {
        const loadMarkdown = async (): Promise<void> => {
            const { default: MarkdownComponent } = await import('react-markdown');
            setMarkdown(() => MarkdownComponent);
        };
        loadMarkdown();
    }, []);

    if (!Markdown) {
        return <div>Loading...</div>;
    }
    return (
        <Markdown
            components={{
                ul: UnorderedList,
                ol: OrderedList,
                li: ListItem,
                h1(props: any) {
                    /* eslint-disable-next-line react/prop-types */
                    const { node, ...rest } = props;
                    return <Heading as="h1" size="lg" {...rest} />;
                },
                h2(props: any) {
                    /* eslint-disable-next-line react/prop-types */
                    const { node, ...rest } = props;
                    return <Heading as="h2" size="md" {...rest} />;
                },
                h3(props: any) {
                    /* eslint-disable-next-line react/prop-types */
                    const { node, ...rest } = props;
                    return <Heading as="h3" size="sm" {...rest} />;
                },
            }}
        >
            {props.markdown}
        </Markdown>
    );
};
